<template>
    <div class="branding">
        <svg
            v-if="collapsed"
            class="branding__logo"
            :class="classes"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 190 168.02">
            <title>Lucro</title>
            <path class="branding__color branding__color--1" d="M149.37,6.86L169.68,42,191,78.89l3,5.12-3,5.11L169.68,126v0l-20.3,35.16L137.51,140.6l14.37-24.89h0L170.2,84,151.88,52.28,137.52,27.4,149.37,6.86h0ZM44.54,161.15L24.23,126,3,89.12,0,84l3-5.12L24.23,42v0L44.53,6.85,56.4,27.43,42,52.32h0L23.71,84,42,115.74l14.36,24.87Z"/>
            <path class="branding__color branding__color--2" d="M137.52,168H97v0H56.4l11.85-20.54H97v0h28.67L137.52,168h0ZM125.65,20.58H97v0H68.28L56.38,0H97V0H137.5L125.65,20.58h0Zm11.87,37H97v0H56.4L68.26,37H97v0h28.67l11.9,20.62h0Zm0,36.78H97v0H56.4L68.26,73.79H97v0h28.67l11.9,20.62h0Zm0,36.67H97v0H56.4l11.85-20.54H97v0h28.67Z"/>
        </svg>
        <svg
            v-else
            class="branding__logo"
            :class="classes"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 620.26 168.02">
            <title>Lucro</title>
            <path class="branding__color branding__color--1" d="M620.26,83a41.25,41.25,0,0,1-12.69,30.1,44.38,44.38,0,0,1-14.13,9.25,43.32,43.32,0,0,1-16.52,3.22,43.86,43.86,0,0,1-16.7-3.23,43.19,43.19,0,0,1-14.06-9.23,41.13,41.13,0,0,1-9.42-13.7,42.2,42.2,0,0,1,9.42-46.61,43,43,0,0,1,14.08-9.19,45.39,45.39,0,0,1,33.28,0A43,43,0,0,1,617,66.66,41.91,41.91,0,0,1,620.26,83h0Zm-13.75,0a31,31,0,0,0-2.25-11.69,30.1,30.1,0,0,0-6.45-9.86,28.35,28.35,0,0,0-9.5-6.56,29.11,29.11,0,0,0-32.39,6.56,29.39,29.39,0,0,0-6.43,9.8A31.48,31.48,0,0,0,547.27,83a30.91,30.91,0,0,0,2.21,11.65,30.18,30.18,0,0,0,6.43,9.8,29.23,29.23,0,0,0,32.27,6.6,29.61,29.61,0,0,0,9.61-6.6,30,30,0,0,0,6.45-9.84A30.52,30.52,0,0,0,606.51,83Z"/>
            <path class="branding__color branding__color--1" d="M471.59,92.33V123.5H459.24V42.36h37.18c14.06,0,26,7.19,26.35,24.05s-8.53,23.36-21.51,25.35l18.16,31.74H505.36l-17.75-31c-5.12,0-11.83-.17-16-0.17h0Zm0.83-10.25h16.05c11.63,0,20.76-3.38,20.76-14.5,0-11.91-8.43-13.89-17.35-13.89H472.42v28.4Z"/>
            <path class="branding__color branding__color--1" d="M442.89,62.09a40.67,40.67,0,0,0-11.82-7.15A36.44,36.44,0,0,0,418,52.56q-13.31,0-21.64,8.53T388,83.21q0,13.14,8.12,21.68t20.49,8.53a37.34,37.34,0,0,0,13.72-2.55,43.48,43.48,0,0,0,12.49-7.7v14.91a38.63,38.63,0,0,1-11.58,5.69,46.58,46.58,0,0,1-13.58,1.89,47.68,47.68,0,0,1-17.21-3,40.58,40.58,0,0,1-23-22.7,44.63,44.63,0,0,1-3.18-16.82,44.13,44.13,0,0,1,3.18-16.76A41.56,41.56,0,0,1,400.5,43.5a45.44,45.44,0,0,1,16.89-3.08A44.58,44.58,0,0,1,431,42.5a48,48,0,0,1,12.58,6.28Z"/>
            <path class="branding__color branding__color--1" d="M291.26,42.36h13V91.63c0,7.32,1.68,12.81,5.07,16.5s10.15,5.51,16.86,5.51,13.44-1.84,16.82-5.51,5.07-9.17,5.07-16.5V42.36h13.19V92.86q0,16.46-8.31,24.63c-5.54,5.45-15.61,8.17-26.76,8.17s-21.21-2.73-26.72-8.15-8.25-13.64-8.25-24.65V42.36Z"/>
            <polygon class="branding__color branding__color--1" points="228.24 123.5 228.24 42.36 241.43 42.36 241.43 111.7 284.59 111.7 284.59 123.5 228.24 123.5"/>
            <path class="branding__color branding__color--1" d="M149.37,6.86L169.68,42,191,78.89l3,5.12-3,5.11L169.68,126v0l-20.3,35.16L137.51,140.6l14.37-24.89h0L170.2,84,151.88,52.28,137.52,27.4,149.37,6.86h0ZM44.54,161.15L24.23,126,3,89.12,0,84l3-5.12L24.23,42v0L44.53,6.85,56.4,27.43,42,52.32h0L23.71,84,42,115.74l14.36,24.87Z"/>
            <path class="branding__color branding__color--2" d="M137.52,168H97v0H56.4l11.85-20.54H97v0h28.67L137.52,168h0ZM125.65,20.58H97v0H68.28L56.38,0H97V0H137.5L125.65,20.58h0Zm11.87,37H97v0H56.4L68.26,37H97v0h28.67l11.9,20.62h0Zm0,36.78H97v0H56.4L68.26,73.79H97v0h28.67l11.9,20.62h0Zm0,36.67H97v0H56.4l11.85-20.54H97v0h28.67Z"/>
        </svg>
    </div>
</template>

<script>
    /**
     * Branding Component
     */
    export default {
        name: 'branding',
        props: {
            type: {
                type: String,
                required: false,
                default: 'light'
            },
            collapsed: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            classes () {
                return {
                    'branding__logo--light': this.type === 'light',
                    'branding__logo--normal': this.type !== 'light'
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";

    .branding {
        display: block;

        &__logo {
            width: 100%;
            height: auto;

            &--light {
                .branding__color--1 { fill: #FFF; }
                .branding__color--2 { fill: #FFF; }
            }
        }

        &__color {
            fill-rule:evenodd;

            &--1 { fill: $primary-color; }
            &--2 { fill: #cacdd3; }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/general/Branding.vue